'use strict';

intellidealerAppCoreModule.filter('urlProtocolNormalization', function ($filter) {
    return function (url) {
        return ['http://', 'https://'].some(protocol => url.startsWith(protocol)) ? url : 'http://' + url;
    };
});
